import { createContext, useContext } from 'react';
import { MainRefContextType } from '../interface/interface';

export const PageScrollContext = createContext<MainRefContextType | null>(null);

export const useMainRef = () => {
  const context = useContext(PageScrollContext);
  return context?.mainRef;
};
